import type { RootState } from '@generalTypes/rootStateTypes';
import type { EditAsideValidityPeriod } from '@nodeTypeConfig/configTypes';
import { selectCurrentEditingNode } from '@store/selectors/asideSelectors';
import { any } from 'prop-types';
import type React from 'react';
import { useSelector } from 'react-redux';
import SimpleInput from './SimpleInput';

const AsideValidityPeriod: React.FC<{
  config: EditAsideValidityPeriod;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const defaultValue = useSelector((state: RootState) => {
    const item = selectCurrentEditingNode(state);
    // @ts-expect-error doesn't know about validityPeriod
    const validityPeriod = item.$$validityPeriod;
    if (!validityPeriod || !validityPeriod.start) {
      return 'Nog niet van toepassing';
    }

    const msg = `Vanaf schooljaar ${validityPeriod.start} ${
      validityPeriod.end ? `tot en met schooljaar ${validityPeriod.end}` : ''
    }`;
    return msg;
  });

  return (
    <SimpleInput
      defaultValue={defaultValue}
      label={config.label}
      readOnly={readonly}
      onChange={(_value) => {}}
    />
  );
};

AsideValidityPeriod.displayName = 'AsideValidityPeriod';

export default AsideValidityPeriod;

AsideValidityPeriod.propTypes = {
  config: any,
  readonly: any,
};
